import { LinkedinSubTypeEnum } from '../../../Common/Basic/enums/linkedin-sub-type.enum';

export class LinkedinDataModel {
    type: LinkedinSubTypeEnum;
    originalActivityData: OriginalLinkedinModel;
    handlePageType: HandlePageTypeEnum;
}

export class OriginalLinkedinModel {
    originalActivityId: string;
    originalUserName: string;
    originalUserHandle: string;
    handlePageType: HandlePageTypeEnum;
}

export enum HandlePageTypeEnum {
    PERSONAL = 'PERSONAL',
    COMPANY = 'COMPANY',
    SHOWCASE = 'SHOWCASE',
    SCHOOL = 'SCHOOL'
}
